import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import LegalAccordion from './LegalAccordion';

const privacySections = [
  {
    title: '1. Information we collect',
    body: (
      <>
        <p>We collect information you provide directly and data generated when you use the service, including:</p>
        <ul>
          <li>
            <strong>Account information:</strong> name, email, phone number, and password (stored in hashed form).
          </li>
          <li>
            <strong>Family profile data:</strong> details you or your family administrator add to the family tree,
            events, messages, photos, and related records.
          </li>
          <li>
            <strong>Usage data:</strong> log data, device type, browser, and interactions needed to secure and improve
            the service.
          </li>
          <li>
            <strong>Payment information:</strong> processed by our payment provider when you subscribe; we do not store
            full card numbers on our servers.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: '2. How we use information',
    body: (
      <p>
        We use collected information to provide, maintain, and personalize FamConnect26; authenticate users and protect
        accounts; communicate about your account, invitations, family activity, or service updates; process
        subscriptions; analyze usage to improve features; and comply with legal obligations. We do not sell your
        personal information to third parties for their marketing purposes.
      </p>
    ),
  },
  {
    title: '3. Sharing within your family network',
    body: (
      <p>
        Information you add may be visible to other members of your family tree according to roles and permissions set
        by your family administrator. Content such as tree details, events, and messages is shared only within the
        family network you belong to, unless you choose to export or share it outside the app. We do not make your
        family data publicly searchable.
      </p>
    ),
  },
  {
    title: '4. Security, retention, and your choices',
    body: (
      <p>
        We may use trusted vendors to host the application, send notifications, process payments, or provide support.
        They access data only to perform services on our behalf and must protect your information. We retain data while
        your account is active and as needed for legal or operational purposes, and we use reasonable measures to
        safeguard it. You may update your profile in settings, request deletion through support, or opt out of
        non-essential communications where offered.
      </p>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy">
      <LegalAccordion sections={privacySections} idPrefix="privacy" />
    </LegalPageLayout>
  );
}
